import { useEffect, useState } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router";
import PrivateRoute from "../route/PrivateRoute";
import PublicRoute from "../route/PublicRoute";
import { authRoutes, publicRoutes } from "./router/router.link";
import { useSelector } from "react-redux";
import portalConfig from "../configurations/gil.config";
import Error404 from "./pages/error/error-404";
 
const AuthRoutes = () => {
  const token = useSelector((state: any) => state.auth.token);
  const isAuthenticated = !!token; // Convert to boolean
  
   const [isTransitioning, setIsTransitioning] = useState(false);
 
  const {
   
    unAuthenticateEntry
  } = portalConfig;
 
  const navigate = useNavigate();
  const location = useLocation();

useEffect(() => {
    // Handle logout transition
    if (!isAuthenticated && location.pathname !== unAuthenticateEntry) {
      setIsTransitioning(true);
     
      // Small delay to prevent flashing error page
      const timer = setTimeout(() => {
        navigate(unAuthenticateEntry || "/");
        setIsTransitioning(false);
      }, 100);
 
      return () => clearTimeout(timer);
    }
  }, [isAuthenticated, navigate, location.pathname, unAuthenticateEntry]);
 
  // Show nothing during transition to prevent error page flash
  // Show loading spinner during transition
if (isTransitioning) {
  return (
      <div id="global-loader">
        <div className="page-loader"></div>
      </div>
    );
}
 
 
 
  return (
 
    <Routes key={isAuthenticated ? "auth" : "guest"}>
    {/* Private Routes */}
    {isAuthenticated ? (
      <Route element={<PrivateRoute />}>
        {authRoutes.map((route, idx) => (
          <Route key={idx} path={route.path} element={route.element} />
        ))}
       
      </Route>
    ) : (
      // Public Routes
      <Route element={<PublicRoute />}>
        {publicRoutes.map((route, idx) => (
          <Route key={idx} path={route.path} element={route.element} />
        ))}
     
      </Route>
    )}
    <Route path="*" element={<Error404 />} />
  </Routes>
 
  );
};
 
function View() {
  return <AuthRoutes />;
}
 
export default View;